<script>
    import Footer from '../landing_page/footer.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    const {title} = rpcjs.props;
    title.set('Privacy | Policy');
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <Navbar colorSent={'white'} />
    </div>
    <div class="mobile ">
        <NavbarMenu backgroundColor="transparent" stroke="white" />
    </div>
    <div class="back-img desktop">
        <div>
            <p class="heading">Draper University - Privacy Policy</p>
        </div>
    </div>
    <div class="back-img-mbl mobile">
        <div>
            <p class="heading-mbl">Draper University - <br />Privacy Policy</p>
        </div>
    </div>
    <div class="main-div">
        <div style="margin-top:7.143vw;">
            <p class="color-text">Last modified: June 18, 2020</p>
            <p class="text-heading">Introduction</p>
            <p class="p-tag">
                Draper University, LLC (“DU”, “we”, “us”, “our,” and terms of
                similar meaning) respect your privacy and are committed to
                protecting it through our compliance with this policy. <br />
                <br />This policy describes the types of information we may
                collect from you or that you may provide when you visit the
                websites at draperuniversity.com and herocity.com (collectively,
                our “Website”) and our practices for collecting, using,
                maintaining, protecting, and disclosing that information.<br />
                <br /> This policy applies to information we collect:
            </p>
            <ul>
                <li class="li-tag">On the Website.</li>
                <li class="li-tag">
                    In email, text, and other electronic messages between you
                    and the Website.
                </li>
                <li class="li-tag">
                    When you attend an event, program, competition, demo day, or
                    other public or private event hosted, coordinated, or
                    operated by DU <br /> (collectively, “Events”), including any
                    audio or visual recordings of these events (“Event Recordings”)
                </li>
                <li class="li-tag">
                    When you interact with our advertising and applications on
                    third-party websites and services, if those applications or
                    advertising include links <br /> to this policy.
                </li>
                <li class="li-tag">
                    It does not apply to information collected by:
                </li>
                <li class="li-tag">
                    Us through any other means, including on any other website
                    operated by DU or any third party (including our affiliates
                    and subsidiaries); or
                </li>
                <li class="li-tag">
                    Any third party (including our affiliates and subsidiaries),
                    including through any application or content (including
                    advertising) that may link to <br /> or be accessible from or
                    on the Website.
                </li>
            </ul>
            <p class="p-tag">
                Please read this policy carefully to understand our policies and
                practices regarding your information and how we will treat it.
                If you do not agree with our policies and practices, your choice
                is not to use our Website. By accessing or using the Website,
                you agree to this privacy policy. This policy may change from
                time to time (see the “Changes to Our Privacy Policy” section
                below). Your continued use of the Website after we make changes
                is deemed to be acceptance of those changes, so please check the
                policy periodically for updates.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Children Under the Age of 13</p>
            <p class="p-tag">
                Our Website is not intended for children under 13 years of age.
                No one under age 13 may provide any information to or on the
                Website. We do not knowingly collect personal information from
                children under 13. If you are under 13, do not use or provide
                any information on the Website or through any of its features,
                register on the Website, make any purchases through the Website,
                use any of the interactive or public comment features of the
                Website, or provide any information about yourself to us,
                including your name, address, telephone number, email address,
                or any screen name or user name you may use. If we learn we have
                collected or received personal information from a child under 13
                without verification of parental consent, we will delete that
                information. If you believe we might have any information from
                or about a child under 13, please contact us at
                <span class="color" style="cursor: pointer;">
                    <a href="mailto:hero@draperuniversity.com">
                        [hero@draperuniversity.com]
                    </a>
                </span><br /> <br /> California residents under 16 years of age may
                have additional rights regarding the collection and sale of their
                personal information. Please see the “Your California Privacy Rights”
                section below for more information.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">
                Information We Collect About You and How We Collect It
            </p>
            <p class="p-tag">
                We collect several types of information from and about users of
                our Website, including information:
            </p>
            <ul>
                <li class="li-tag">
                    By which you may be personally identified, such as your
                    name, address, email address, phone number, social security
                    number, marketing preferences, location data (if combined
                    with other identifiers), photos, video footage with your
                    likeness, audio recordings, payment card number, financial,
                    educational, and professional records, and any form of
                    biometric, gender-based, sexual preference, age-related, or
                    other identifying personal data (“personal information”);
                </li>
                <li class="li-tag">
                    That is about you but individually does not identify you;
                    and/or
                </li>
                <li class="li-tag">
                    About your internet connection, the equipment you use to
                    access our Website, and usage details.
                </li>
                <li class="li-tag">
                    DU acts as a “data controller” (defined terms used that are
                    not otherwise defined in this Privacy Policy are defined
                    terms used in the EU General Data Protection Regulation
                    (“GDPR”)). For more information on the GDPR, please go to <span
                        class="color"
                        style="cursor:pointer"
                        on:click={() =>
                            (location.href = 'https://gdpr-info.eu/')}
                        >https://gdpr-info.eu/</span
                    >.
                </li>
                <li class="li-tag">We collect this information:</li>
                <li class="li-tag">
                    Directly from you when you provide it to us, for example,
                    when you sign up for our newsletter or submit an application
                    to one of our programs.
                </li>
                <li class="li-tag">
                    Automatically as you navigate through the site. Information
                    collected automatically may include usage details, IP
                    addresses, and
                </li>
                <li class="li-tag">
                    Information collected through cookies, web beacons, and
                    other tracking technologies.
                </li>
                <li class="li-tag">
                    When you attend an Event, including via any Event
                    Recordings.
                </li>
            </ul>
            <p class="p-tag">
                <b>Information You Provide to Us</b><br /> <br />The information
                we collect on or through our Website may include:
            </p>
            <ul>
                <li class="li-tag">
                    Information that you provide by filling in forms on our
                    Website. This includes information provided at the time of
                    registering to use our Website, subscribing to our services
                    (including DU programs), posting material, or requesting
                    further services. We may also ask you for information when
                    you enter a promotion sponsored by us, and when you report a
                    problem with our Website.
                </li>
                <li class="li-tag">
                    Records and copies of your correspondence (including email
                    addresses), if you contact us.
                </li>
                <li class="li-tag">
                    Your responses to surveys that we might ask you to complete
                    for research purposes.
                </li>
                <li class="li-tag">
                    Details of transactions you carry out through our Website
                    and of the fulfillment of your orders. You may be required
                    to provide financial information before placing an order
                    through our Website.
                </li>
                <li class="li-tag">Your search queries on the Website.</li>
            </ul>
            <p class="p-tag">
                You also may provide information to be published or displayed
                (hereinafter, “<b>posted</b>”) on public areas of the Website,
                or transmitted to other users of the Website or third parties
                (collectively, “<b>User Contributions</b>”). Your User
                Contributions are posted on and transmitted to others at your
                own risk. Although we limit access to certain pages, please be
                aware that no security measures are perfect or impenetrable.
                Additionally, we cannot control the actions of other users of
                the Website with whom you may choose to share your User
                Contributions. Therefore, we cannot and do not guarantee that
                your User Contributions will not be viewed by unauthorized
                persons.
            </p>
            <p class="p-tag">
                <b
                    >Information We Collect Through Automatic Data Collection
                    Technologies</b
                ><br /> <br />As you navigate through and interact with our
                Website, we may use automatic data collection technologies to
                collect certain information about your equipment, browsing
                actions, and patterns, including:
            </p>
            <ul>
                <li class="li-tag">
                    Details of your visits to our Website, including traffic
                    data, location data, logs, and other communication data and
                    the resources that you access and use on the Website.
                </li>
                <li class="li-tag">
                    Information about your computer and internet connection,
                    including your IP address, operating system, and browser
                    type.
                </li>
            </ul>
            <p class="p-tag">
                DU does not track its users over time and across third party
                websites to provide targeted advertising and therefore does not
                respond to Do Not Track (DNT) signals. Third parties that have
                content embedded on the Website may set cookies on your browser
                and/or obtain information about you when you use the Website.
                For information on these practices, see the “Third-Party Use of
                Cookies and Other Tracking Technologies” section below.
            </p>
            <p class="p-tag">
                The information we collect automatically is only statistical
                data and does not include personal information. It helps us to
                improve our Website and to deliver a better and more
                personalized service, including by enabling us to:
            </p>
            <ul>
                <li class="li-tag">
                    Estimate our audience size and usage patterns.
                </li>
                <li class="li-tag">
                    Store information about your preferences, allowing us to
                    customize our Website according to your individual
                    interests.
                </li>
                <li class="li-tag">Speed up your searches.</li>
                <li class="li-tag">
                    Recognize you when you return to our Website.
                </li>
            </ul>
            <p class="p-tag">
                The technologies we use for this automatic data collection may
                include:
            </p>
            <p class="p-tag">
                <b>Cookies (or browser cookies).</b>A cookie is a small file
                placed on the hard drive of your computer. You may refuse to
                accept browser cookies by activating the appropriate setting on
                your browser. However, if you select this setting you may be
                unable to access certain parts of our Website. Unless you have
                adjusted your browser setting so that it will refuse cookies,
                our system will issue cookies when you direct your browser to
                our Website.
            </p>
            <p class="p-tag">
                <b>Flash Cookies.</b>Certain features of our Website may use
                local stored objects (or Flash cookies) to collect and store
                information about your preferences and navigation to, from, and
                on our Website. Flash cookies are not managed by the same
                browser settings as are used for browser cookies. For
                information about managing your privacy and security settings
                for Flash cookies, see the “Choices About How We Use and
                Disclose Your Information” section below.
            </p>
            <p class="p-tag">
                <b>Web Beacons.</b>Pages of our the Website and our e-mails may
                contain small electronic files known as web beacons (also
                referred to as clear gifs, pixel tags, and single-pixel gifs)
                that permit DU, for example, to count users who have visited
                those pages or opened an email and for other related website
                statistics (for example, recording the popularity of certain
                website content and verifying system and server integrity).
            </p>
            <p class="p-tag">
                <b>Analytics:</b>We use Google Analytics, a web analytics
                service provided by Google, Inc. (“Google”). Google Analytics
                uses cookies to help us analyze how users use the Website and
                enhance your experience when you use the Website. For more
                information on how Google uses this data, go to
                www.google.com/policies/privacy/partners/.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">
                Third-Party Use of Cookies and Other Tracking Technologies
            </p>
            <p class="p-tag">
                Some content or applications on the Website are served by
                third-parties, including content providers and application
                providers. These third parties may use cookies alone or in
                conjunction with web beacons or other tracking technologies to
                collect information about you when you use the Website. The
                information they collect may be associated with your personal
                information or they may collect information, including personal
                information, about your online activities over time and across
                different websites and other online services. They may use this
                information to provide you with interest-based (behavioral)
                advertising or other targeted content.<br /> <br /> We do not control
                these third parties’ tracking technologies or how they may be used.
                For information about how you can opt out of receiving targeted advertising
                from many providers, see the “Choices About How We Use and Disclose
                Your Information” section below.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">How We Use Your Information</p>
            <p class="p-tag">
                We use information that we collect about you or that you provide
                to us, including any personal information:
            </p>
            <ul>
                <li class="li-tag">
                    To present our Website and its contents to you.
                </li>
                <li class="li-tag">
                    To provide you with information, products, or services that
                    you request from us.
                </li>
                <li class="li-tag">
                    To fulfill any other purpose for which you provide it.
                </li>
                <li class="li-tag">
                    To provide you with notices, such as service announcements,
                    technical notices, updates, security alerts, and support and
                    administrative messages
                </li>
                <li class="li-tag">
                    To carry out our obligations and enforce our rights arising
                    from any contracts entered into between you and us,
                    including for billing and collection.
                </li>
                <li class="li-tag">
                    To notify you about changes to our Website or any products
                    or services we offer or provide though it.
                </li>
                <li class="li-tag">
                    To notify you about any products or services offered by our
                    affiliates or subsidiaries.
                </li>
                <li class="li-tag">
                    To allow you to participate in interactive features on our
                    Website.
                </li>
                <li class="li-tag">
                    In any other way we may describe when you provide the
                    information.
                </li>
                <li class="li-tag">For any other purpose with your consent.</li>
            </ul>
            <p class="p-tag">
                We may also use your information to contact you about our own
                goods and services that may be of interest to you. If you do not
                want us to use your information in this way, please see the
                “Choices About How We Use and Disclose Your Information” section
                below.<br />
                <br /> We may also use any Event Recordings as part of our marketing
                and promotional activities. Further, we may also publish any Event
                Recordings, including any audio or video therein, in connection with
                our documentation of or publicity relating to those Events, for example,
                on the DU website or a relevant Event-specific page. We may seek
                your consent or a release from you in the event the nature of our
                processing requires such consent or release. However, in certain
                circumstances, we may process or publish certain video, images, etc.
                without your consent, such as when we publish on an Event page certain
                Event Recordings that include images of groups or crowds in attendance
                at an Event.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Disclosure of Your Information</p>
            <p class="p-tag">
                We may disclose aggregated information about our users, and
                information that does not identify any individual, without
                restriction. <br />
                We may disclose personal information that we collect or you provide
                as described in this privacy policy:
            </p>
            <ul>
                <li class="li-tag">To our subsidiaries and affiliates.</li>
                <li class="li-tag">
                    To contractors, service providers, and other third parties
                    we use to support our business, including the DU programs.
                </li>
                <li class="li-tag">
                    To a buyer or other successor in the event of a merger,
                    divestiture, restructuring, reorganization, dissolution, or
                    other sale or transfer of some or all of Draper University,
                    LLC’s assets, whether as a going concern or as part of
                    bankruptcy, liquidation, or similar proceeding, in which
                    personal information held by Draper University, LLC about
                    our Website users is among the assets transferred.
                </li>
                <li class="li-tag">
                    To fulfill the purpose for which you provide it.
                </li>
                <li class="li-tag">
                    For any other purpose disclosed by us when you provide the
                    information.
                </li>
                <li class="li-tag">With your consent.</li>
            </ul>
            <p class="p-tag">We may also disclose your personal information:</p>
            <ul>
                <li class="li-tag">
                    To comply with any court order, law, or legal process,
                    including to respond to any government or regulatory
                    request.
                </li>
                <li class="li-tag">
                    To enforce or apply our Terms of Use
                    <span
                        class="color"
                        style="cursor:pointer;"
                        on:click={() =>
                            (location.href =
                                'https://www.draperuniversity.com/terms-of-use')}
                        >https://www.draperuniversity.com/terms-of-use</span
                    >
                    and other agreements, including for billing and collection purposes.
                </li>
                <li class="li-tag">
                    If we believe disclosure is necessary or appropriate to
                    protect the rights, property, or safety of Draper
                    University, LLC, our customers, or others. This includes
                    exchanging information with other companies and
                    organizations for the purposes of fraud protection and
                    credit risk reduction.
                </li>
            </ul>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">
                International Transfers of Your Personal Information
            </p>
            <p class="p-tag">
                DU is headquartered in the United States and personal
                information we collect from you will be processed in the United
                States. The United States has not sought nor received a finding
                of “adequacy” from the European Union under Article 45 of the
                GDPR. We aim to collect and transfer personal information only:
                (i) with your consent; (ii) to perform a contract with you; or
                (iii) to fulfill a compelling legitimate interest in a manner
                that does not outweigh your rights and freedoms.<br /><br /> By providing
                us with your personal information, you acknowledge and agree that
                we may from time to time transfer any of your personal information
                to any of our offices, agents, partners, or appointed representatives
                located around the world. Please do not submit any personal information
                to us if you do not wish for your data to be transferred internationally.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">
                Choices About How We Use and Disclose Your Information
            </p>
            <p class="p-tag">
                We strive to provide you with choices regarding the personal
                information you provide to us. We have created mechanisms to
                provide you with the following control over your information: <br
                /><br />Tracking Technologies and Advertising. You can set your
                browser to refuse all or some browser cookies, or to alert you
                when cookies are being sent. To learn how you can manage your
                Flash cookie settings, visit the Flash player settings page on
                Adobe’s website. If you disable or refuse cookies, please note
                that some parts of this site may then be inaccessible or not
                function properly.<br /><br />
                Promotional Offers from DU. If you do not wish to have your email
                address used by DU to promote our own products or services (or products
                and services of our affiliates and subsidiaries), you can opt-out
                by checking the relevant box located on the form on which we collect
                your data or at any other time by sending us an email stating your
                request to
                <span style="cursor: pointer;">
                    <a href="mailto:hero@draperuniversity.com">
                        [hero@draperuniversity.com]
                    </a>
                </span>. If we have sent you a promotional email, you may send
                us a return email asking to be omitted from future email
                distributions. This opt out does not apply to information
                provided to DU as a result of a product purchase, product
                service experience or other transactions. <br /><br />We do not
                control third parties’ collection or use of your information to
                serve interest-based advertising. However, these third parties
                may provide you with ways to choose not to have your information
                collected or used in this way. You can opt out of receiving
                targeted ads from members of the Network Advertising Initiative
                (“NAI”) on the NAI’s website.<br /><br /> California residents
                may have additional personal information rights and choices.
                Please see the “Your California Privacy Rights” section below
                for more information.<br /><br /> Nevada residents who wish to
                exercise their sale opt-out rights under Nevada Revised Statutes
                Chapter 603A may submit a request to this designated address:
                <span class="color" style="cursor: pointer;">
                    <a href="mailto:hero@draperuniversity.com">
                        [hero@draperuniversity.com]
                    </a>
                </span> However, please know we do not currently sell data triggering
                that statute’s opt-out requirements.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Accessing and Correcting Your Information</p>
            <p class="p-tag">
                You may send us an email at <span
                    class="color"
                    style="cursor: pointer;"
                >
                    <a href="mailto:hero@draperuniversity.com">
                        [hero@draperuniversity.com]
                    </a></span
                >
                to request access to, correct or delete any personal information
                that you have provided to us. We may not accommodate a request to
                change information if we believe the change would violate any law
                or legal requirement or cause the information to be incorrect.
                <br /><br />If you delete your User Contributions from the
                Website, copies of your User Contributions may remain viewable
                in cached and archived pages, or might have been copied or
                stored by other Website users. Proper access and use of
                information provided on the Website, including User
                Contributions, is governed by our Terms of Use
                <span
                    class="color"
                    style="cursor:pointer;"
                    on:click={() =>
                        (location.href =
                            'https://www.draperuniversity.com/terms-of-use')}
                    >[https://www.draperuniversity.com/terms-of-use]</span
                >.<br /><br /> California residents may have additional personal
                information rights and choices. Please see the “Your California Privacy
                Rights” section below for more information.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Your California Privacy Rights</p>
            <p class="p-tag">
                If you are a California resident, California law may provide you
                with additional rights regarding our use of your personal
                information. To learn more about your California privacy rights,
                visit our CCPA Privacy Notice for California Residents
                <span class="color" style="cursor:pointer;" on:click={() => (location.href = 'https://www.draperuniversity.com/ccpa')}>
                    [https://www.draperuniversity.com/ccpa]</span
                >.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Data Security</p>
            <p class="p-tag">
                We have implemented measures designed to secure your personal
                information from accidental loss and from unauthorized access,
                use, alteration, and disclosure.<br /><br /> The safety and
                security of your information also depends on you. We urge you to
                be careful about giving out information in public areas of the
                Website like message boards. The information you share in public
                areas may be viewed by any user of the Website.<br /><br /> Unfortunately,
                the transmission of information via the internet is not completely
                secure. Although we do our best to protect your personal information,
                we cannot guarantee the security of your personal information transmitted
                to our Website. Any transmission of personal information is at your
                own risk. We are not responsible for circumvention of any privacy
                settings or security measures contained on the Website.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Changes to Our Privacy Policy</p>
            <p class="p-tag">
                It is our policy to post any changes we make to our privacy
                policy on this page. If we make material changes to how we treat
                our users’ personal information, we will notify you by email
                and/or through a notice on the Website home page. The date the
                privacy policy was last revised is identified at the top of the
                page. You are responsible for ensuring we have an up-to-date
                active and deliverable email address for you, and for
                periodically visiting our Website and this privacy policy to
                check for any changes.
            </p>
        </div>
        <div class="margin-top desktop">
            <hr class="hr-css" />
        </div>
        <div class="margin-top">
            <p class="text-heading">Contact Information</p>
            <p class="p-tag">
                To ask questions or comment about this privacy policy and our
                privacy practices, contact us at: <span
                    class="color"
                    style="cursor: pointer;"
                >
                    <a href="mailto:hero@draperuniversity.com">
                        [hero@draperuniversity.com]
                    </a>
                </span>

                >
            </p>
        </div>
    </div>
    <div style="margin-top:2.8vw">
        <Footer />
    </div>
</section>

<style>
    .back-img {
        height: 39.683vw;
        background-image: url("images/privacy_page/privacy_bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    .heading {
        padding-top: 28.3vw;
        font-weight: 600;
        color: white;
        font-size: 4.037vw;
        text-align: center;
    }
    .back-img-mbl {
        height: 116.111vw;
        background-image: url("images/privacy_page/privacy-bgmbl.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    .heading-mbl {
        padding-top: 79.444vw;
        font-weight: 600;
        color: white;
        font-size: 8.333vw;
        margin-left: 8.333vw;
    }

    .text-heading {
        font-weight: 600;
        font-size: 1.984vw;
        margin-bottom: 2.05vw;
    }
    .hr-css {
        border: 0.066vw solid #262525;

    }
    .main-div {
        padding: 0 8.598vw;
    }
    .p-tag {
        font-size: 1.19vw;
        line-height: 1.323vw;
    }
    .li-tag {
        font-size: 1.19vw;
        padding: 1vw 0vw;
    }
    .margin-top {
        margin-top: 2.050vw;
    }
    .color {
        color: #3c74c0;
    }
    .color-text {
        color: #3c74c0;
        font-size: 1.323vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }

    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .text-heading {
            font-size: 4.444vw !important;
        }
        .p-tag {
            font-size: 3.056vw !important;
            line-height: 4.166vw;
        }
        .li-tag {
            font-size: 3.056vw !important;
            padding: 1vw 0vw !important;
        }
        .color-text {
            font-size: 2.936vw !important;
        }
        .margin-top {
            margin-top: 8.2vw !important;
        }
    }
</style>
